import { OptionProps, components } from 'react-select';

import { GitCredential } from '@/react/portainer/account/git-credentials/types';
import { useGitCredentials } from '@/react/portainer/account/git-credentials/git-credentials.service';
import { useUser } from '@/react/hooks/useUser';
import { Badge } from '@/react/components/Badge';

import { FormControl } from '@@/form-components/FormControl';
import { Select } from '@@/form-components/ReactSelect';

function CredentialOption(props: OptionProps<GitCredential, false>) {
  const { data: gitCred } = props;
  return (
    <div>
      {/* eslint-disable-next-line react/jsx-props-no-spreading */}
      <components.Option {...props}>
        <div className="flex items-center gap-1">
          <span>{gitCred.name}</span>
          {gitCred.userId === 0 && (
            <Badge type="info" className="ml-1">
              Shared
            </Badge>
          )}
        </div>
      </components.Option>
    </div>
  );
}

export function CredentialSelector({
  value,
  onChange,
  error,
}: {
  value?: number;
  onChange(gitCredential?: GitCredential | null): void;
  error?: string;
}) {
  const { user } = useUser();

  const gitCredentialsQuery = useGitCredentials(user.Id, {
    includeShared: true,
  });

  const gitCredentials = gitCredentialsQuery.data ?? [];

  return (
    <div className="form-group">
      <div className="col-sm-12">
        <FormControl
          label="Git Credentials"
          inputId="git-creds-selector"
          errors={error}
        >
          <Select
            placeholder="select git credential or fill in below"
            value={gitCredentials.find(
              (gitCredential) => gitCredential.id === value
            )}
            options={gitCredentials}
            getOptionLabel={(gitCredential) => gitCredential.name}
            getOptionValue={(gitCredential) => gitCredential.id.toString()}
            onChange={onChange}
            isClearable
            noOptionsMessage={() => 'no saved credentials'}
            inputId="git-creds-selector"
            data-cy="git-credentials-selector"
            id="git-credentials-selector"
            components={{ Option: CredentialOption }}
          />
        </FormControl>
      </div>
    </div>
  );
}
